import { render } from "./RequisicionPagoHistorico.vue?vue&type=template&id=a2767b18"
import script from "./RequisicionPagoHistorico.vue?vue&type=script&lang=js"
export * from "./RequisicionPagoHistorico.vue?vue&type=script&lang=js"

import "./RequisicionPagoHistorico.vue?vue&type=style&index=0&id=a2767b18&lang=scss"

import exportComponent from "C:\\AgentesAzure\\SVRAPQAHIR01\\vsts-agent-win-x64-4.261.0\\_work\\4\\s\\hircasa-srp-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__